
const m = window.require("discourse/helpers/decorate-username-selector");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
